<template>
  <div class="page-wrapper">
    <h2 class="tw-mb-6">Übersicht - Alle Kunden</h2>

    <div class="clients-filters tw-mb-4">
      <div class="tw-flex tw-flex-col tw-gap-1">
        <label class="fox-label--simple">
          Suchen
        </label>
        <form class="tw-relative" @submit.prevent="fetchClients()">
          <input
            type="text"
            v-model="searchParams.keyword"
            class="fox-input--simple fox-input--simple-search tw-w-full tw-bg-white"
          >

          <div class="tw-absolute tw-inset-y-0 tw-right-2 tw-flex tw-items-center">
            <v-icon class="tw-cursor-pointer" @click="fetchClients()">mdi-magnify</v-icon>
          </div>
        </form>
      </div>

      <div class="tw-flex tw-flex-col tw-gap-1">
        <label class="fox-label--simple">
          Kunde
        </label>
        <div class="tw-relative">
          <select v-model="searchParams.uuid" @change="fetchClients()" class="fox-input--simple fox-input--simple-select tw-w-full tw-bg-white tw-capitalize">
            <option selected value="">Kunde auswählen</option>
            <option v-for="client in filters.clients" :key="client.uuid" :value="client.uuid">
              {{ client.name }}
            </option>
          </select>

          <div class="tw-absolute tw-inset-y-0 tw-right-1 tw-flex tw-items-center tw-pointer-events-none">
            <v-icon>mdi-menu-down</v-icon>
          </div>
        </div>
      </div>

      <div class="tw-flex tw-flex-col tw-gap-1">
        <label class="fox-label--simple">
          Status
        </label>
        <div class="tw-relative">
          <select v-model="searchParams.status" @change="fetchClients()" class="fox-input--simple fox-input--simple-select tw-w-full tw-bg-white tw-capitalize">
            <option selected value="">Status auswählen</option>
            <option v-for="status in filters.statusFilters" :key="status.value" :value="status.value">
              {{ status.text }}
            </option>
          </select>

          <div class="tw-absolute tw-inset-y-0 tw-right-1 tw-flex tw-items-center tw-pointer-events-none">
            <v-icon>mdi-menu-down</v-icon>
          </div>
        </div>
      </div>
    </div>

    <div class="clients-form tw-mb-6">
      <h3 class="tw-text-lg tw-font-bold tw-mb-4">Neuen Kunden anlegen</h3>

      <div class="tw-grid tw-grid-cols-1 md:tw-grid-cols-2 tw-gap-2 md:tw-gap-8 tw-mb-4">
        <div class="tw-w-full tw-flex tw-flex-col tw-gap-2">
          <input
            v-model="biller.company"
            type="text"
            placeholder="Unternehmen / Rechtsform"
            class="fox-input--simple tw-w-full"
          >

          <input
            v-model="biller.name"
            type="text"
            placeholder="Name"
            class="fox-input--simple tw-w-full"
            v-bind:class="classes.name"
          >

          <input
            v-model="biller.address"
            type="text"
            placeholder="Straße und Hausnummer"
            class="fox-input--simple tw-w-full"
            v-bind:class="classes.address"
          >
        </div>

        <div class="tw-w-full tw-flex tw-flex-col tw-gap-2">
          <div class="tw-flex tw-gap-2">
            <input
              v-model="biller.zipCode"
              type="text"
              placeholder="PLZ"
              class="fox-input--simple tw-w-full"
            >

            <input
              v-model="biller.city"
              type="text"
              placeholder="Stadt"
              class="fox-input--simple tw-w-full"
            >
          </div>

          <input
            v-model="biller.country"
            type="text"
            placeholder="Land"
            class="fox-input--simple tw-w-full"
          >

          <input
            v-model="biller.email"
            type="email"
            placeholder="Email"
            class="fox-input--simple tw-w-full"
          >
        </div>
      </div>

      <div class="tw-flex tw-justify-end">
        <button class="btn-gradient btn-gradient--small" @click="addClient">
          Speichern
        </button>
      </div>
    </div>

    <div class="table-block">
      <h3 class="tw-text-xl tw-font-bold tw-mb-3">Alle Kunden</h3>

      <div class="tw-flex tw-flex-wrap tw-gap-x-6 tw-gap-y-1 tw-mb-6">
        <span class="text-link tw-cursor-pointer tw-font-bold" @click="selectAllClients">alle auswählen</span>

        <span class="text-link" v-if="selectedClientUuids.length > 0">{{ selectedClientUuids.length }} ausgewählt</span>

        <span class="text-link tw-cursor-pointer tw-font-bold" @click="updateClientStatus('ACTIVE')">als aktiv markieren</span>
        <span class="text-link tw-cursor-pointer tw-font-bold" @click="updateClientStatus('REMOVED')">als gekündigt markieren</span>
        <span class="text-link tw-cursor-pointer tw-font-bold" @click="updateClientStatus('CANCELED')">stornieren</span>
        <span class="text-link tw-cursor-pointer tw-font-bold" @click="updateClientStatus('DELETED')">löschen</span>
      </div>

      <div class="app-table-wrapper">
        <table class="app-table">
          <thead>
            <tr>
              <th>Kunde</th>
              <th>Email</th>
              <th>PLZ</th>
              <th>Letzte RG</th>
              <th>ANZAHL-RG</th>
              <th>Status</th>
              <th>UMSATZ (Netto)</th>
              <th>Ust.</th>
              <th>Umsatz (BRUTTO)</th>
            </tr>
          </thead>

          <tbody>
            <tr v-for="client in clients" :key="client.uuid">
              <td>
                <div class="tw-flex tw-items-center tw-gap-6" style="min-height: 44px;">
                  <label class="custom-checkbox">
                    <input
                      type="checkbox"
                      v-model="selectedClientUuids"
                      :value="client.uuid"
                    />
                    <span class="checkmark"></span>
                  </label>

                  <div class="tw-flex tw-flex-col tw-text-left">
                    <span class="tw-inline-block tw-font-medium tw-truncate" style="max-width: 180px;">{{ client.name }}</span>
                    <span class="tw-inline-block tw-text-gray-500 tw-truncate" style="max-width: 180px;">{{ client.company }}</span>
                  </div>
                </div>
              </td>

              <td>
                <span class="tw-inline-block tw-font-medium tw-truncate" style="max-width: 120px;">{{ client.email }}</span>
              </td>

              <td>
                <span class="tw-font-medium tw-whitespace-nowrap">{{ client.zipCode }}</span>
              </td>

              <td>
                <span class="tw-font-medium tw-whitespace-nowrap">{{ client.invoiceStats.lastCreatedAt }}</span>
              </td>

              <td>
                <span class="tw-font-medium tw-whitespace-nowrap">{{ client.invoiceStats.totalInvoice }}</span>
              </td>

              <td>
                <div class="tw-relative">
                  <select
                    class="app-table-select tw-capitalize"
                    :class="{
                      'app-table-select--active': client.status.value === 'ACTIVE',
                      'app-table-select--error': client.status.value === 'REMOVED'
                    }"
                    :value="client.status.value"
                    @change="updateClientStatus($event.target.value, client.uuid)"
                  >
                    <option v-for="status in filters.statusFilters" :key="status.value" :value="status.value" :selected="client.status.value === status.value">
                      {{ status.text }}
                    </option>
                  </select>

                  <div class="tw-absolute tw-inset-y-0 tw-right-1 tw-flex tw-items-center tw-pointer-events-none">
                    <v-icon>mdi-menu-down</v-icon>
                  </div>
                </div>
              </td>

              <td>
                <span class="tw-font-medium tw-whitespace-nowrap">{{ client.invoiceStats.totalNetto }} {{ client.invoiceStats.unit }}</span>
              </td>

              <td>
                <span class="tw-font-medium tw-whitespace-nowrap">{{ client.invoiceStats.totalTax }} {{ client.invoiceStats.unit }}</span>
              </td>

              <td>
                <span class="tw-font-bold tw-whitespace-nowrap">{{ client.invoiceStats.totalBrutto }} {{ client.invoiceStats.unit }}</span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="tw-mt-8 tw-mb-4">
        <AppPagination
          v-if="totalCount > 0"
          :count="totalCount"
          :currentPage="currentPage"
          @update="(page) => fetchClients(page)"
        />
      </div>
    </div>
  </div>
</template>

<script>
import ApiService from '@/services/api.service'
import useVuelidate from '@vuelidate/core'
import { required } from '@vuelidate/validators'
import AppPagination from '@/components/Common/AppPagination.vue'

export default {
  name: 'AllClients',
  components: {
    AppPagination
  },
  setup: () => ({ v$: useVuelidate() }),
  data () {
    return {
      email: '',
      filters: {},
      biller: {
        name: '',
        address: '',
        company: '',
        zipCode: '',
        city: '',
        country: '',
        email: ''
      },
      clients: [],
      selectedClientUuids: [],
      currentPage: 1,
      totalCount: 0,
      searchParams: {
        keyword: '',
        status: '',
        uuid: ''
      }
    }
  },
  mounted () {
    this.fetchUserStatus()
    this.fetchFilters()
    this.fetchClients()
  },
  methods: {
    async fetchUserStatus () {
      try {
        const userResponse = await ApiService.get('/user/status')
        this.email = userResponse.data.email
      } catch (error) {
        this.$router.push({ name: 'Login' })
      }
    },
    async fetchFilters () {
      try {
        const response = await ApiService.get('/client/filter/get')
        this.filters = response.data
      } catch (error) {
        console.error('Error fetching filters:', error)
      }
    },
    async addClient () {
      const isFormCorrect = await this.v$.$validate()

      if (isFormCorrect) {
        await ApiService.post('/client/create', this.biller)
          .then(response => {
            console.log('Client added successfully:', response.data)
            this.resetForm()
            this.currentPage = 1
            this.searchParams = {
              keyword: '',
              status: '',
              uuid: ''
            }
            this.fetchClients()
          })
          .catch(error => {
            console.error('Error adding client:', error)
          })
      }
    },
    resetForm () {
      this.biller = {
        name: '',
        address: '',
        company: '',
        zipCode: '',
        city: '',
        country: '',
        email: ''
      }
      this.v$.$reset()
    },
    async fetchClients (page) {
      if (page) {
        this.currentPage = page
      }
      try {
        const response = await ApiService.get('/client/search', {
          params: {
            page: this.currentPage,
            keyword: this.searchParams.keyword,
            status: this.searchParams.status,
            uuid: this.searchParams.uuid
          }
        })
        this.clients = response.data.data
        this.currentPage = response.data.pagination.page
        this.totalCount = response.data.pagination.total
      } catch (error) {
        console.error('Error fetching clients:', error)
      }
    },
    async updateClientStatus (status, uuids = null) {
      try {
        const uuidArray = uuids
          ? (Array.isArray(uuids) ? uuids : [uuids])
          : this.selectedClientUuids

        const payload = uuidArray.map(uuid => ({
          uuid,
          status
        }))

        if (!payload.length) return

        await ApiService.post('/client/status/update', payload)
        this.fetchClients()
      } catch (error) {
        console.error('Error updating client status:', error)
      }
    },
    selectAllClients () {
      const currentPageUuids = this.clients.map(client => client.uuid)
      this.selectedClientUuids = Array.from(new Set([...this.selectedClientUuids, ...currentPageUuids]))
    }
  },
  validations () {
    return {
      biller: {
        name: { required },
        address: { required }
      }
    }
  },
  computed: {
    classes: function () {
      return {
        name: {
          'fox-input--error': this.v$.biller.name.$error
        },
        address: {
          'fox-input--error': this.v$.biller.address.$error
        }
      }
    }
  }
}
</script>
